module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"cancel":"Annuler","title-select":"Choisissez votre tarif :"},"en":{"cancel":"Cancel","title-select":"Choose your fare:"}}')
  delete Component.options._Ctor
}
